import React, { useContext } from "react"
import Slider from "react-slick"

import { ThemeContext } from "Components"

import { InlineLink, CenterSection, SliderContent } from "Styles"
import { theme } from "Theme"

import { TwitterTweetEmbed } from "react-twitter-embed"
import Config from "Data"

import styled from "styled-components"

const TweetsGrid = styled.div`
  color: inherit;
  width: 100%;
  position: relative;
  z-index: 3;
  padding: 0rem 0rem 2rem;
  margin: 2rem auto 0;
  max-width: ${theme.layout.base};

  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100%, 1fr));
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    grid-template-columns: repeat(auto-fill, minmax(30%, 1fr));
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
  grid-gap: 16px;
`

const SliderSettings = {
  // className: 'xxx',
  // dotsClass: 'aaa',
  autoplay: true,
  useTransform: true,

  dots: true,
  infinite: true,
  speed: 800,
  slidesToShow: 3,
  slidesToScroll: 1,
  pauseOnHover: true,
  initialSlide: 1,
  responsive: [
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 1,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 1,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
        infinite: true,
        dots: true,
      },
    },
  ],
}

const SectionTweets = ({ data, title, brand, subtitle, tweets, children, background }) => {
  const { mode } = useContext(ThemeContext)
  return (
    <CenterSection.Wrapper background={background}>
      <CenterSection.Content>
        {title && (
          <CenterSection.Title mode={mode}>
            {`${title}`}{" "}
            {brand && (
              <InlineLink
                to={`https://twitter.com/${Config.twitter}`}
                track={"Tweets Section | Twitter Link"}
                title={`${Config.twitter} on Twitter`}
                style={{
                  fontWeight: "bold",
                  textDecoration: "none",
                  color: `${theme.colors.primary.base}`,
                }}>
                {Config.twitterHandle}
              </InlineLink>
            )}
          </CenterSection.Title>
        )}
        {subtitle && <CenterSection.Subtitle>{`${data.subtitle}`}</CenterSection.Subtitle>}
        <SliderContent>
          {tweets.length <= 3 && (
            <TweetsGrid className={"no-padding"}>
              {tweets.map((tweet, i) => (
                <TwitterTweetEmbed
                  key={i}
                  tweetId={tweet.node.tweetId}
                  options={{
                    // cards: "hidden",
                    // hideCard: true,
                    hideThread: false,
                    conversation: "none",
                    theme: "light",
                    linkColor: `${theme.colors.primary.base}`,
                    borderColor: `${theme.colors.primary.base}`,
                    width: "auto",
                    align: "center",
                  }}
                />
              ))}
            </TweetsGrid>
          )}
          {tweets.length > 3 && (
            <Slider {...SliderSettings}>
              {tweets.map((tweet, i) => (
                <TwitterTweetEmbed
                  key={i}
                  tweetId={tweet.node.tweetId}
                  options={{
                    cards: "hidden",
                    hideCard: true,
                    hideThread: false,
                    conversation: "none",
                    theme: "light",
                    linkColor: `${theme.colors.primary.base}`,
                    borderColor: `${theme.colors.primary.base}`,
                    width: "auto",
                    align: "center",
                  }}
                />
              ))}
            </Slider>
          )}
        </SliderContent>
        {children}
      </CenterSection.Content>
    </CenterSection.Wrapper>
  )
}

export default SectionTweets
